Array.fromLength = function(length) {
  return [...Array(length + 1).keys()];
};

export const ArrayToJson = (array) => {
  const json = {};
  array.forEach((item, index) => {
    json[index + 1] = item;
  });
  // const JsonToServer = JSON.stringify(json);
  return json;
};
